import React from 'react';

const sizeClassNames = {
  sm: {
    spinner: 'h-9 w-9 border-2',
    dot: 'h-2 w-2',
  },
  md: {
    spinner: 'h-10 w-10 border-2',
    dot: 'h-2.5 w-2.5',
  },
  lg: {
    spinner: 'h-12 w-12 border-[3px]',
    dot: 'h-3 w-3',
  },
};

const LoadingIndicator = ({ size = 'md', className = '' }) => {
  const classes = sizeClassNames[size] || sizeClassNames.md;

  return (
    <div
      className={`flex flex-col items-center justify-center gap-4 ${className}`}
      role="status"
      aria-label="Loading"
    >
      <div className="relative flex items-center justify-center">
        <span
          aria-hidden="true"
          className={`${classes.spinner} rounded-full border-zinc-200 border-t-zinc-700 motion-safe:animate-spin dark:border-zinc-700 dark:border-t-zinc-100`}
        />
        <span
          aria-hidden="true"
          className={`${classes.dot} absolute rounded-full bg-zinc-500 dark:bg-zinc-300`}
        />
      </div>
    </div>
  );
};

export default LoadingIndicator;
